module.exports = __webpack_public_path__ + "assets/3aae12dfc408e31823c2a0d9b684ee71.mp3";